import { render, staticRenderFns } from "./AssignOwnership.vue?vue&type=template&id=19d66e92"
import script from "./AssignOwnership.vue?vue&type=script&lang=js"
export * from "./AssignOwnership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports